import { render, staticRenderFns } from "./FieldTagsInput.vue?vue&type=template&id=01fbd2a6"
import script from "./FieldTagsInput.vue?vue&type=script&lang=js"
export * from "./FieldTagsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports